
    <ng-container nbCellOutlet></ng-container>